import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { useAppDispatch } from 'store';

import { errorHandler, globalConst, setLimitOpen } from 'modules/global';

import { ITestData } from '../models';
import { getThemedTestQuiz } from '../queries';
import { setTestData, topicTestsConst } from '..';

export const useThemedTestQuiz = (testId: string | string[] | undefined) => {
  const { push } = useRouter();
  const dispatch = useAppDispatch();

  return useQuery<ITestData>({
    queryKey: [topicTestsConst.queryKeys.USE_TOPIC_TEST_QUIZ, testId],
    queryFn: () => getThemedTestQuiz(testId),
    enabled: !!testId,
    refetchOnMount: true,
    onSuccess: data => {
      dispatch(setTestData(data));
    },
    onError: (error: any) => {
      if (error?.response?.status === 403 && error?.response?.data?.message?.is_allowed === false) {
        dispatch(
          setLimitOpen({
            open: true,
            nextOpenTime: error?.response?.data?.message?.next_open_test
          })
        );

        push(globalConst.pageNames.TOPIC_TEST);
      } else {
        errorHandler();
      }
    }
  });
};
